import {
  AttachmentFieldDefinition,
  DateTimeFieldDefinition,
  DurationFieldDefinition,
  ListFieldDefinition,
  LookupFieldDefinition,
  NumericFieldDefinition,
  OptionsetFieldDefinition,
  StringFieldDefinition,
} from '@msdk/definitions'

type HtmlTags = 'button' | 'tab' | 'icon' | 'link' | 'svg'

type Field =
  | NumericFieldDefinition
  | OptionsetFieldDefinition
  | AttachmentFieldDefinition
  | DateTimeFieldDefinition
  | StringFieldDefinition
  | ListFieldDefinition
  | LookupFieldDefinition
  | DurationFieldDefinition

export const getTag = (ctx?: string, pageCtx?: string, cta?: string, htmlTagName?: HtmlTags): string => {
  return `${ctx ?? 'PORTAL'}-${pageCtx}-${cta}-${htmlTagName}`.toUpperCase()
}

export const getTagFromNode = (fd: Field, ctx?: string): string => {
  return `${ctx ?? 'PORTAL'}-${fd.name}-${fd.fieldDefinitionType}`.toUpperCase()
}

export const getCustomTag = (labels: string[] = []): string => {
  let res = ''
  labels.forEach((e, i) => {
    res = res.concat(e)
    if (i !== labels.length - 1) {
      res = res.concat('-')
    }
  })
  return res.toUpperCase().replaceAll(' ', '')
}
